import React from "react";

const Page404 = () => {
    return (
        <div className={"container postsFeed"}>
            <div className={"listEnd mTop"}>
                <h1>404 Page Not Found</h1>
                <p>Return to <a href={"/"}>Home Page?</a></p>
            </div>
        </div>
    )
}

export default Page404;